import { Routes } from '@angular/router';
import { ApplicationRouteEnum } from './constants/route-enum';

export default [
  {
    path: '',
    loadComponent: () =>
      import('./pages/application-list/application-list.component'),
  },
  {
    path: ApplicationRouteEnum.ApplicationDetails + '/:id',
    loadComponent: () =>
      import('./pages/application-details/application-details.component'),
    data: {
      breadcrumb: ApplicationRouteEnum.ApplicationDetails,
    },
  },
] as Routes;
